import 'css-chunksrc/client/scenes/milestoneCompletion/form/styles.scss';export default {
  "form": "_form_dk4n3_1",
  "section": "_section_dk4n3_10",
  "freeDateCheckBox": "_freeDateCheckBox_dk4n3_28",
  "label": "_label_dk4n3_37"
};